module.exports = __webpack_public_path__ + "static/media/AmazonMusic.208af56a.svg";